export default __webpack_public_path__ + "static/media/harisankar.defb6e17.JPG";